import { render } from 'preact';
import { App } from './ui/App';
import { InstallPrompt } from './ui/InstallPrompt';
import { UpdatePrompt } from './ui/UpdatePrompt';
import { requestPersistentStorage } from './ui/storage';
import './ui/styles.css';

const root = document.getElementById('app');
if (!root) {
  throw new Error('Missing #app mount point in index.html');
}

// The whole schedule lives in this origin's IndexedDB with no backup, so ask
// the browser to protect it from eviction. Fire-and-forget: rendering must
// never wait on a storage prompt.
void requestPersistentStorage();

// App shortcuts (long-press icon → "Add a class") launch with ?action=…
const launchAction = new URLSearchParams(window.location.search).get('action');

/**
 * The service worker is registered here rather than inside `App` so that the
 * component tree stays free of the `virtual:pwa-register` module, which only
 * exists during a Vite build.
 */
function Root() {
  return (
    <>
      {/* One fixed slot above the tab bar for in-app banners. */}
      <div class="banner-stack">
        <UpdatePrompt />
      </div>
      {/* Renders its own overlay dialog, so it lives outside the stack. */}
      <InstallPrompt />
      <App startNewClass={launchAction === 'new-class'} />
    </>
  );
}

render(<Root />, root);
